export default __webpack_public_path__ + "static/media/FUSE.380fa22b.svg";